import React from 'react';

/**
 * Small "How this works" link to a role guide, placed at the moment of need
 * (submit form, review view, confirm panel, …). Opens in a new tab so it
 * never navigates away from in-progress work.
 */
interface GuideLinkProps {
  href: string;
  label?: string;
}

const GuideLink: React.FC<GuideLinkProps> = ({ href, label = 'How this works' }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      fontSize: 12.5,
      color: '#2E5477',
      textDecoration: 'underline',
      textUnderlineOffset: 2,
      whiteSpace: 'nowrap'
    }}
  >
    {label} ↗
  </a>
);

export default GuideLink;
